<template>
    <div class="z-max-500">
        <slot name="header">
            <div class="ma-2">
                <v-icon>mdi-account-check-outline</v-icon>
                <span class="text--primary font-weight-bold ml-2">{{ $translate(title) }}</span>
            </div>
            <span v-if="subTitle" class="text--secondary">{{ subTitle }}</span>
        </slot>
        <v-form>
            <v-radio-group v-model="selectedMethodId">
                <div v-for="method in loginMethods" :key="method.id" class="z-rounded-border my-1">

                    <div class="d-flex ml-2">
                        <v-radio :label="method.title" color="primary" :value="method.id" class="flex-grow-1 mb-0" :ref="'radio-' + method.id" />
                        <img v-if="method.imagekey" :src="$api.getImageUrl(method.imagekey, 100)" class="ma-1" style="height: 36px; width: 36px" />
                        <div v-else-if="method.icon">
                            <v-icon
                                size="36"
                                class="ma-1"
                                :color="method.icon.color"
                            >{{ method.icon.icon }}</v-icon>
                        </div>
                    </div>

                    <div v-if="method.id == selectedMethodId" class="ml-10 mr-2">
                        <terms-notice v-if="selectedMethodId != 'mail' && selectedMethodId != 'maillogin'" />
                        <template v-if="selectedMethodId == 'bankid'">
                            <zoezi-bankid size="200"></zoezi-bankid>
                        </template>

                        <template v-else-if="selectedMethodId == 'mail'">
                            <template v-if="!mail.existing && !mail.createNew">
                                <v-row no-gutters>
                                    <v-col cols=12>
                                        <!-- fixme: enter should submit form -->
                                        <v-text-field :label="$translate('Email address / username')" v-model.trim="mail.mail" autofocus class="ml-2 ml-md-0" id="mailident" :disabled="mail.checking" @keypress.enter.prevent="mailProceed" />
                                    </v-col>
                                </v-row>

                                <terms-notice />
                                <div class="d-flex">
                                    <v-spacer />

                                    <zoezi-button :text="$translate('Continue')" :disabled="!mail.mail" class="mb-2" :loading="mail.checking" @click="mailProceed" />
                                </div>
                            </template>
                            <template v-else-if="mail.existing">

                                <div class="d-flex">
                                    <div>{{$translate('Welcome back')}} <span class="font-weight-bold">{{mail.existing}}!</span></div>
                                    <div @click="notMyAccount" class="flex-grow-1 z-clickable primary--text text-decoration-underline text-right">{{$translate('Not my account!')}}</div>
                                </div>

                                <v-form @submit.prevent="mailLogin">
                                    <v-row no-gutters>
                                        <v-col cols=6 md=12>
                                            <v-text-field :label="$translate('Email address / username')" class="mr-2 mr-md-0" disabled :value="mail.mail" />
                                        </v-col>
                                        <v-col cols=6 md=12>
                                            <v-text-field :label="$translate('Password')" v-model="mail.password" class="ml-2 ml-md-0" type="password" id="passwordident" :disabled="mail.logginIn" />
                                        </v-col>
                                    </v-row>

                                    <terms-notice />
                                    <div class="d-flex mb-2">
                                        <div @click="forgotPassword" class="flex-grow-1 z-clickable primary--text text-decoration-underline">{{$translate('I have forgotten the password')}}</div>
                                        <zoezi-button :text="$translate('Log in')" :disabled="!passwordLoginOk" type="submit" :loading="mail.loggingIn" />
                                    </div>
                                </v-form>
                            </template>
                            <template v-else-if="mail.createNew">
                                <div class="mb-2">{{$translate('Hi! You seem to be new here, welcome!')}}</div>
                                <div style="font-size: smaller">{{$translate('Do you already have an account?')}}</div>
                                <div style="font-size: smaller" @click="mail.existing = false; mail.createNew = false" class="z-clickable primary--text">{{$translate('Log in with other credentials')}}</div>

                                <v-form v-model="mail.createNewValid" @submit.prevent="mailCreateNew">
                                    <form-field v-for="field in registerFields" :key="field.key" :field="field" star
                                                v-model="field.value" />
                                    <terms-notice />
                                    <div class="d-flex">
                                        <v-spacer />

                                        <v-btn color="primary" class="mb-2 mr-2 zoezi-button-thin" @click="mail.existing = false; mail.createNew = false" outlined>{{$translate('Back')}}</v-btn>

                                        <zoezi-button :text="$translate('Continue')" :disabled="!mail.createNewValid" class="mb-2" :loading="mail.creatingNew" type="submit" />
                                    </div>
                                </v-form>
                            </template>

                        </template>

                        <template v-else-if="selectedMethodId == 'maillogin'">
                            <v-form @submit.prevent="mailLogin">
                                <v-row no-gutters>
                                    <v-col cols=6 md=12>
                                        <v-text-field :label="$translate('E-mail')" class="mr-2 mr-md-0" autofocus v-model.trim="mail.mail" />
                                    </v-col>
                                    <v-col cols=6 md=12>
                                        <v-text-field :label="$translate('Password')" v-model="mail.password" class="ml-2 ml-md-0" type="password" id="passwordident" :disabled="mail.logginIn" />
                                    </v-col>
                                </v-row>

                                <terms-notice />
                                <div class="d-flex mb-2">
                                    <div @click="forgotPassword" class="flex-grow-1 text-decoration-underline primary--text z-clickable">{{$translate('I have forgotten the password')}}</div>
                                    <zoezi-button :text="$translate('Log in')" :disabled="!passwordLoginOk" type="submit" :loading="mail.loggingIn" />
                                </div>
                            </v-form>
                        </template>

                        <template v-else-if="selectedMethodId == 'google'">
                            <div v-if="isExpoApp()">
                                <zoezi-button :text="$translate('Log in with Google')" class="my-2" @click="expoGoogleSignIn" />
                            </div>
                            <iframe v-else src="https://service.zoezi.se/googleauth/" frameborder="0"
                                    style="border: none; overflow: hidden; width: auto; height: 44px">
                            </iframe>
                        </template>

                        <template v-else-if="selectedMethodId == 'facebook'">
                            <iframe src="https://service.zoezi.se/fbauth/sdk.html" frameborder="0"
                                    style="border: none; overflow: hidden; width: auto; height: 60px">
                            </iframe>
                        </template>

                        <template v-else-if="selectedMethodId == 'apple'">
                            <AppleSignin style="padding: 10px"/>
                        </template>

                        <template v-else>
                            {{method.title}} {{$translate('is selected')}}
                        </template>

                    </div>
                </div>
            </v-radio-group>
        </v-form>

        <v-dialog v-if="mail.showForgotPasswordDialog" max-width="500" v-model="mail.showForgotPasswordDialog">
            <v-card>
                <v-card-title class="headline">{{$translate('Forgot password')}}</v-card-title>

                <v-card-text>
                    <v-text-field :label="$translate('Email address')" v-model="mail.mail" />
                    <div v-if="mail.forgotMailSent">{{$translate('We have sent you an email with information on how to reset your password')}}</div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <zoezi-button
                        :disabled="!mailValid"
                        @click="sendForgotPasswordMail"
                        :text="$translate('Send reset link')" />
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-if="mail.forgotMailSent" max-width="500" v-model="mail.forgotMailSent">
            <v-card>
                <v-card-title class="headline">{{$translate('Mail sent')}}</v-card-title>

                <v-card-text>
                    <div>{{$translate('We have sent you an email with information on how to reset your password')}}</div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <zoezi-button
                        @click="mail.forgotMailSent = false"
                        :text="$translate('Great!')" />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>


<script>
import { isValidPersonalCode, isValidMail, isExpoApp, appHandlesAppleSignin } from '../util.js';
import FormField from '../components/FormField.vue'
import AppleSignin from '../components/AppleSignin.vue';
import zoeziBankid from '../components/BankId.vue'
import TermsNotice from '../components/TermsNotice.vue'
import Vue from 'vue';

export default {
    name: 'zoezi-identification',

    props: {
        title: {
            type: String,
            default: 'Complete your payment by identifying yourself'
        },
        subTitle: {
            type: String,
            default: ''
        }
    },

    components: {
        FormField,
        AppleSignin,
        zoeziBankid,
        TermsNotice
    },

    data: () => ({
        selectedMethodId: null,
        errorMessage: '',

        rules: {
            personalCodeNumber: x => x && x.length >= 10 && !isValidPersonalCode(x) ? this.$translate('Incorrect social security number') : true
        },

        mail: {
            mail: null,
            password: null,
            passwordLimit: location.hostname == 'zoezidev.se' || window.__devenv ? 3 : 6,
            checking: false,
            existing: null,
            createNew: false,
            creatingNew: false,
            showForgotPasswordDialog: false,
            createNewValid: false,
            forgotMailSent: false
        },

        registerFields: []
    }),

    computed: {
        loginMethods() {
            // Mobilt BankID, Google, Facebook, Fyll i uppgifter

            let res = [];
            let settings = this.$store.state.settings;
            if (!settings) {
                return res;
            }

            if (settings.login?.bankid) {
                res.push({id: 'bankid', title: 'Mobile BankID', imagekey: this.$api.getAssetUrl('/assets/img/bankid.svg')});
            }

            if (settings.login?.google) {
                res.push({id: 'google', title: 'Google', imagekey: this.$api.getAssetUrl('/assets/img/google.png')});
            }

            if (settings.login?.facebook) {
                res.push({id: 'facebook', title: 'Facebook', imagekey: this.$api.getAssetUrl('/assets/img/facebook.png')});
            }

            if (this.showAppleSignin) {
                res.push({id: 'apple', title: 'Apple', icon: { icon: "mdi-apple", color: "#000000" }});
            }

            if (settings.login?.mail) {
                res.push({id: 'mail', title: 'Email address / username', imagekey: this.$api.getAssetUrl('/assets/img/manreg.png')});
            }

            return res.map(x => {
                x.title = this.$translate(x.title);
                return x;
            });
        },
        mailValid() {
            return isValidMail(this.mail.mail);
        },
        passwordLoginOk() {
            return this.mail.password && this.mail.password.length >= this.mail.passwordLimit && (this.selectedMethodId == 'maillogin' || this.mail.existing);
        },
        facebook() {
            return !!this.loginMethods.find(x => x.id == 'facebook');
        },
        showAppleSignin() {
            let settings = this.$store.state.settings;

            // Apple requires us to handle apple sign in if we have any other 3rd party sign in method from the app store application. (They dont seem to care about bankid)
            let has3rdpartySignin = Object.keys(settings.login).some(method => method !== 'mail' && method !== 'bankid' && settings.login[method]);

            if (settings.login?.apple) {
                // Will not display apple sign in if the device does not support it through our expo app.
                return this.isExpoApp() ? appHandlesAppleSignin() === true : true;
            } else {
                return has3rdpartySignin && appHandlesAppleSignin() === true;
            }
        }
    },
    watch: {
        'mail.existing'(existing) {
            if (existing) {
                Vue.nextTick(() => {
                    document.getElementById('passwordident').focus();
                });
            }
        },
        loginMethods: {
            immediate: true,
            handler(methods) {
                if (methods && methods.length == 1 && methods[0].id == 'mail') {
                    this.selectedMethodId = 'mail';
                }
            }
        },
        '$store.state.settings.fields': {
            immediate: true,
            handler(fields) {
                if (fields && this.registerFields.length == 0) {
                    fields = fields.concat();
                    let pw = fields.find(x => x.builtIn && x.name == 'password');
                    if (!pw) {
                        fields.push({
                            builtIn: true,
                            name: 'password',
                            required: true,
                            title: 'Password',
                            register: true,
                            show: true,
                            changeable_by_member: true,
                            icon: 'icon glyphicon glyphicon-asterisk'
                        })
                    } else {
                        pw.required = true;
                        pw.register = true;
                    }

                    this.registerFields = fields.filter(field => field.register).map(field => {
                        let title = field.title;
                        if (field.builtIn && ['firstname', 'lastname'].includes(field.name)) {
                            title = 'Your ' + field.name;
                        }
                        return Object.assign({}, field, {value: null, key: field.builtIn + field.name, title});
                    })
                }
            }
        },
        errorMessage(text) {
            if (this.errorMessage) {
                text = this.$translate(text);
                this.$store.commit('showSnackBar', {text});
            }
        }
    },
    methods: {
        personalCodeNumberChanged() {
            if (this.selectedMethodId == 'mail') {
                if (isValidPersonalCode(this.mail.personalCodeNumber)) {
                    document.getElementById('mailident').focus();
                }
            }
        },
        mailProceed() {
            this.mail.checking = true;
            this.errorMessage = '';
            this.$api.post('/api/memberapi/probeLogin', null, {mail: this.mail.mail}).then(response => {
                if (!response.ok) {
                    response.json().then(data => {
                        this.errorMessage = data.message || 'An error occurred';
                    }).catch(() => {
                        this.errorMessage = 'An error occurred';
                    }).finally(() => {
                        this.mail.checking = false;
                    });
                    return;
                }
                response.json().then(result => {
                    let found = result.result;
                    if (found) {
                        this.mail.existing = result.name;
                    } else {
                        this.mail.createNew = true;
                        let mail = this.registerFields.find(x => x.name == 'mail' && x.builtIn);
                        if (mail) {
                            if (isValidMail(this.mail.mail)) {
                                mail.value = this.mail.mail;
                                mail.readonly = true;
                            } else {
                                mail.value = null;
                                mail.readonly = false;
                            }
                            let login_key = this.registerFields.find(x => x.name == 'login_key' && x.builtIn);
                            if (login_key) {
                                login_key.value = this.mail.mail;
                            }
                        }
                        let pcode = this.registerFields.find(x => x.name == 'personalCodeNumber' && x.builtIn);
                        if (pcode) {
                            pcode.value = this.mail.personalCodeNumber;
                        }
                    }

                    this.mail.checking = false;
                });
            })
        },
        mailLogin() {
            this.mail.loggingIn = true;
            this.errorMessage = '';
            let data = {login: this.mail.mail, password: this.mail.password};
            this.$api.post('/api/v8.0/memberapi/login', data).then(response => {
                response.json().then(data => {
                    if (response.ok) {
                        this.errorMessage = '';
                        this.$store.commit('setLoggedIn', {isLoggedIn: true, user: data});
                        this.$store.commit('hideSnackBar');
                    } else {
                        this.errorMessage = data.message;
                    }

                    this.mail.loggingIn = false;
                });
            });
        },
        forgotPassword() {
            this.mail.showForgotPasswordDialog = true;
        },
        sendForgotPasswordMail() {
            this.$api.post('/api/memberapi/requestResetPassword', null, {mail: this.mail.mail}).then(response => {
                if (response.ok) {
                    this.mail.showForgotPasswordDialog = false;
                    this.mail.forgotMailSent = true;
                } else {
                    this.$store.commit('showErrorDialog', {title: this.$translate('Incorrect email address'), text: this.$translate('No user with the given email address could be found.')})
                }
            })
        },
        notMyAccount() {
            this.mail.existing = null;
        },
        mailCreateNew() {
            this.mail.creatingNew = true;
            let member = {do_login: true, xf: {}};
            this.registerFields.forEach(x =>  {
                if (x.builtIn) {
                    member[x.name] = x.value;
                } else {
                    member.xf[x.name] = x.value
                }
            })
            if (this.$store.state?.settings?.acceptterms?.id) {
                member.terms = {id: this.$store.state.settings.acceptterms.id}
            }
            if (!member.homesite_id && this.$store.state.settings?.sites?.length > 1 && this.$store.state.selectedSiteId) {
                member.homesite_id = this.$store.state.selectedSiteId;
            }
            this.$api.post('/api/memberapi/add', member).then(response => {
                this.mail.creatingNew = false;
                response.json().then(data => {
                    if (response.ok) {
                        this.errorMessage = '';
                        this.$store.commit('setLoggedIn', {isLoggedIn: true, user: data});
                    } else {
                        this.errorMessage = data.message;
                    }
                });

            });
        },
        isExpoApp,
        expoGoogleSignIn() {
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'googleAuth' }));
            }
        }
    },
    mounted() {
        // FIXME: Only if methods says it's included
        window.addEventListener('message', (event) => {
            if (event.data && event.data.id_token) {
                this.$store.dispatch('googleSignIn', event.data.id_token);
            } else if (event.data?.fb_access_token) {
                this.$api.post('/api/memberapi/fblogin', null, {token: event.data.fb_access_token}).then(response => {
                    response.json().then(data => {
                        if (response.ok) {
                            this.errorMessage = '';
                            this.$store.commit('setLoggedIn', {isLoggedIn: true, user: data});
                        } else {
                            this.errorMessage = data.message;
                        }
                    })
                });
            }
        }, false);
    }
}

</script>
